import {
  add,
  filter,
  fromPairs,
  groupBy,
  head,
  last,
  map,
  modify,
  pipe,
  reduce,
  sortBy,
  toPairs,
  toString,
  values,
} from 'ramda';

import { type QuizMatchTrack } from '@/app/l/[region]/[language]/quiz-match/[course]/quiz-match.urls';
import { type DatoCourse } from '@/lib/datocms';
import { type CourseAnswer } from '../../icon-question';

type ScorableAnswer = Pick<CourseAnswer, 'courses'>;

type MaybeScorableAnswer = ScorableAnswer | Record<string, unknown>;

const getScore = ([, score]: [string, number]) => score;

export const calculateWinningTrack = (
  answers: MaybeScorableAnswer[]
): QuizMatchTrack => {
  const tiePriority: QuizMatchTrack[] = [
    'ai',
    'da',
    'wd',
    'cy',
    'ux',
    'ml',
    'dv',
    'mk',
  ];
  const initialWeights: Record<string, 0> = pipe(
    map((track: string): [string, 0] => [track, 0]),
    fromPairs
  )(tiePriority);

  const highestScoreTrack: QuizMatchTrack = pipe(
    filter((answer: MaybeScorableAnswer) => 'courses' in answer) as (
      a: MaybeScorableAnswer[]
    ) => ScorableAnswer[],
    reduce(
      (answerLoopAcc: Record<string, number>, { courses }: ScorableAnswer) =>
        courses.reduce(
          (
            courseLoopAcc: Record<string, number>,
            { code }: Pick<DatoCourse, 'code'>
          ) => modify(code, add(2), courseLoopAcc),
          answerLoopAcc
        ),
      initialWeights
    ),
    toPairs,
    sortBy(getScore),
    groupBy(pipe(getScore, toString)),
    values,
    last,
    map(head),
    head as (a: QuizMatchTrack[]) => QuizMatchTrack
  )(answers);

  return highestScoreTrack;
};
